
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function GuaranteeSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="garantia" className="py-16 sm:py-24 bg-gradient-to-b from-dark to-navy-dark">
      <div ref={sectionRef} className="max-w-4xl mx-auto px-4 sm:px-6">
        <div 
          className={`relative bg-gradient-to-br from-primary/10 via-accent-cyan/5 to-primary/10 border-2 border-primary/50 rounded-2xl sm:rounded-3xl p-6 sm:p-12 text-center overflow-hidden transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <div className="absolute inset-0 bg-gradient-radial from-primary/10 via-transparent to-transparent"></div>
          
          <div className="relative">
            <div 
              className={`w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-gradient-to-r from-primary to-accent-cyan rounded-xl sm:rounded-2xl transition-all duration-500 ${
                isVisible ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-0 rotate-180'
              }`}
              style={{ transitionDelay: '200ms' }}
            >
              <i className="ri-shield-check-line text-2xl sm:text-4xl text-dark"></i>
            </div>

            <h2 
              className={`text-xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '300ms' }}
            >
              Garantia <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent-cyan">Tempo ou Dinheiro de Volta</span>
            </h2>

            <p 
              className={`text-sm sm:text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-6 sm:mb-8 transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '400ms' }}
            >
              Se em <strong className="text-white">7 dias</strong> você não economizar pelo menos{' '}
              <strong className="text-primary">5 horas semanais</strong> em atendimento manual, devolvemos{' '}
              <strong className="text-white">100% do seu investimento</strong>.
            </p>

            <div 
              className={`inline-block px-6 sm:px-8 py-2 sm:py-3 bg-gradient-to-r from-primary to-accent-cyan text-dark font-bold text-lg sm:text-xl rounded-full whitespace-nowrap transition-all duration-500 shadow-lg shadow-primary/30 ${
                isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
              }`}
              style={{ transitionDelay: '500ms' }}
            >
              7 Dias
            </div>

            <p 
              className={`mt-4 sm:mt-6 text-xs sm:text-sm text-gray-400 transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '600ms' }}
            >
              Sem burocracia. Sem perguntas. Garantia total.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
